import { GroupUpdatesMessage } from "Types";
import { MyInsightsSearch, QuickInsightsSearch } from "../types";
import { sortMySearches, sortQuickSearches } from "./utils";

export const updateMySearchesCache = (
  draft: MyInsightsSearch[],
  message: GroupUpdatesMessage,
): MyInsightsSearch[] => {
  if (message.entity === "my_search") {
    if (message.action === "updated") {
      const notUpdatedSearches = draft.filter(
        (search) => !message.keys.includes(search.id),
      );

      return sortMySearches([...notUpdatedSearches, ...message.data]);
    }
  }

  return draft;
};

export const updateQuickSearchesCache = (
  draft: QuickInsightsSearch[],
  message: GroupUpdatesMessage,
): QuickInsightsSearch[] => {
  if (message.entity === "quick_search") {
    if (message.action === "updated") {
      const notUpdatedSearches = draft.filter(
        (search) => !message.keys.includes(search.id),
      );

      return sortQuickSearches([...notUpdatedSearches, ...message.data]);
    }
  }

  return draft;
};
